// extracted by mini-css-extract-plugin
export default {"nameInput":"NameInput_nameInput__XbVT7"};